import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { NavBadgeGroup } from "@/components/NavBadge";
import { ViewportEdgeNav } from "@/components/ViewportEdgeNav";
import { useNavBadges } from "@/hooks/useNavBadges";
import { useCurrentUser } from "@/lib/auth";
import type { NavItem } from "@/lib/nav";

export function BestellwesenNav({ items }: { items: NavItem[] }) {
  const { user } = useCurrentUser();
  const badgeCounts = useNavBadges(user);

  return (
    <ViewportEdgeNav>
      <nav className="eh-project-detail-nav" aria-label="Bestellwesen">
        <ul className="eh-project-detail-nav__list" role="list">
          {items.map((item) => (
            <li key={item.key}>
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  clsx(
                    "eh-project-detail-nav__item",
                    isActive && "eh-project-detail-nav__item--active",
                  )
                }
              >
                <span className="eh-project-detail-nav__label">{item.label}</span>
                <NavBadgeGroup
                  badgeKeys={item.badgeKeys}
                  badgeSumKeys={item.badgeSumKeys}
                  counts={badgeCounts}
                />
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </ViewportEdgeNav>
  );
}
